export type InlineAdSlotSchema = {
  attribs: InlineAdSlotSchemaAttributes;
  type: typeof InlineAdSlotSchemaType;
};

export const InlineAdSlotSchemaType = "inline-ad-slot";

export type InlineAdSlotSchemaAttributes = {
  tag: string;
};

export function isInlineAdSlotSchema(node: SchemaNode): node is InlineAdSlotSchema {
  return node.type === InlineAdSlotSchemaType;
}

export type InlineAdSlotSchemaRow = {
  row: number;
} & InlineAdSlotSchema;

export function defineInlineAdSlotSchema(options: {
  row: number;
  tag: string;
}): InlineAdSlotSchemaRow {
  const { row, tag } = options;
  return {
    attribs: {
      tag,
    },
    row,
    type: InlineAdSlotSchemaType,
  };
}
